import { render, staticRenderFns } from "./addSensor.vue?vue&type=template&id=6ed35f3d&scoped=true"
import script from "./addSensor.vue?vue&type=script&lang=js"
export * from "./addSensor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed35f3d",
  null
  
)

export default component.exports